export interface GodModeBootRequest {
  enabled: boolean;
  token?: string;
  forceMinigameId?: string;
}

export function readGodModeTokenFromHash(hash: string): string | null {
  const normalized = hash.startsWith('#') ? hash.slice(1) : hash;
  if (normalized.length === 0) return null;
  const token = new URLSearchParams(normalized).get('god')?.trim() ?? '';
  return token.length > 0 ? token : null;
}

export function readForceMinigameIdFromSearch(search: string): string | null {
  const params = new URLSearchParams(search);
  const id =
    params.get('force-minigame') ?? params.get('forceMinigame') ?? params.get('force_minigame');
  const normalized = id?.trim() ?? '';
  return normalized.length > 0 ? normalized : null;
}

export function resolveGodModeBootRequest(args: {
  search: string;
  hash: string;
  dev: boolean;
}): GodModeBootRequest {
  const forceMinigameId = readForceMinigameIdFromSearch(args.search) ?? undefined;
  const withForce = (request: GodModeBootRequest): GodModeBootRequest =>
    forceMinigameId == null ? request : { ...request, forceMinigameId };

  const token = readGodModeTokenFromHash(args.hash);
  if (token != null) return withForce({ enabled: true, token });
  if (args.dev && new URLSearchParams(args.search).get('god') === '1') {
    return withForce({ enabled: true });
  }
  return withForce({ enabled: false });
}

export function scrubGodModeHash(
  location: Pick<Location, 'pathname' | 'search'>,
  history: Pick<History, 'replaceState' | 'state'>,
): void {
  history.replaceState(history.state, document.title, `${location.pathname}${location.search}`);
}
